import { I as Icon, _ as __assign, a as __rest, l as loadable$2 } from './loadable.esm-8884282c.js';
import React from 'react';

var PercentageIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 16 16" }),
    React.createElement("path", { d: "M8 0C3.58866667 0 0 3.58866667 0 8c0 4.4113333 3.58866667 8 8 8 4.4113333 0 8-3.5886667 8-8 0-4.41133333-3.5886667-8-8-8zM4 5.33333333C4 4.59666667 4.59666667 4 5.33333333 4 6.07 4 6.66666667 4.59666667 6.66666667 5.33333333 6.66666667 6.07 6.07 6.66666667 5.33333333 6.66666667 4.59666667 6.66666667 4 6.07 4 5.33333333zm1.33333333 6.27599997l-.94266666-.9426666 6.27600003-6.27600003.9426666.94266666-6.27599997 6.27599997zM10.6666667 12C9.93 12 9.33333333 11.4033333 9.33333333 10.6666667c0-.7366667.59666667-1.33333337 1.33333337-1.33333337C11.4033333 9.33333333 12 9.93 12 10.6666667 12 11.4033333 11.4033333 12 10.6666667 12z" }))); };

var PercentageIcon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': PercentageIcon
});

var ProxyPercentageIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return Promise.resolve().then(function () { return PercentageIcon$1; }); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { PercentageIcon as P, ProxyPercentageIcon as a };
